module.exports = {"content":{},"productInfo":{"code":"{39E168F8-0C2C-4C4E-8DDA-74AB649AFE81}","name":"中国語（マンダリン）　初中級","serialHead":"AYWRK","courseResourceIDs":[{"levelNo":1,"resourceID":"4e9db76049d09c53d1684bc8a94fd1fa221c5eca"},{"levelNo":2,"resourceID":"9a1291ca1c15e198c8a39c0bfe3ef1f7a0ec4a28"},{"levelNo":3,"resourceID":"924e9c7fb3a3da91dc2d8cbc75bc1c6034e08c56"},{"levelNo":4,"resourceID":"dd7871f52393c9aea1b4cedd3db05e03bf8dda54"},{"levelNo":5,"resourceID":"69734f614608601d156904f79a92cb9d658d0dbb"}],"language":"zh-CN","challengeCount":33951},"version":"1.1.0"}


//////////////////
// WEBPACK FOOTER
// ./static/data.json
// module id = 207
// module chunks = 1